import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { StyledAccordion, StyledAccordionSummary } from './Styled'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Column } from 'src/components/Layout/Styled'
import Detail from './Detail'
import { StyledDivider } from './Styled'
import dayjs from 'dayjs'

const EnrollInfoItem = ({ index }) => {
  const { enroll } = useSelector(
    (state) => ({
      enroll: state.eLearningEnroll.body.enroll[index],
    }),
    shallowEqual
  )
  return (
    <StyledAccordion defaultExpanded>
      <StyledAccordionSummary
        expandIcon={<ExpandMoreIcon></ExpandMoreIcon>}
      ></StyledAccordionSummary>
      <Column
        sx={{
          rowGap: '12px',
        }}
      >
        <Detail label="คำนำหน้าชื่อ" value={enroll.prefixTH} />
        <Detail label="ชื่อ" value={`${enroll.firstNameTH}`} />
        <Detail label="นามสกุล" value={`${enroll.lastNameTH}`} />
        <StyledDivider />
        <Detail label="Title Name" value={enroll.prefix} />
        <Detail label="First Name" value={`${enroll.firstName}`} />
        <Detail label="Last Name" value={`${enroll.lastName}`} />
        <StyledDivider />
        <Detail label="บัตรประชาชน" value={enroll.idCardNo} />
        <Detail
          label="วัน เดือน ปี เกิด"
          value={
            enroll.birthDate
              ? dayjs(enroll.birthDate).toDate().toLocaleDateString('th-TH', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })
              : '-'
          }
        />
        <Detail label="หมายเลขโทรศัพท์มือถือ" value={enroll.mobileNo} />
        <Detail label="อีเมล" value={enroll.email} />
      </Column>
    </StyledAccordion>
  )
}

export default EnrollInfoItem
